<div class="cookie-policy ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>

  <div class="ya-bottomsheet-container">
    <div class="ya-dialog-content">
      <div class="container">
        <div class="cookie-policy-container">
          <div class="cookie-policy_icon">
            <div class="icon-container">
              <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-cookie"></div>
            </div>
          </div>
        </div>
        <div class="text-container">
          <h3 langkey="phCookieStatement_Title_First"></h3>
          <div>
            <p>
              {{cookieDeclaration}}
            </p>
          </div>
        </div>

        <div class="text-container">
          <h3 langkey="phCookieStatement_Title_Second"></h3>

          <table mat-table [dataSource]="tableDataSource" multiTemplateDataRows>
            <ng-container matColumnDef="{{column}}"
              *ngFor="let column of displayedColumns; let isLast = last; let isFirst = first">
              <th mat-header-cell *matHeaderCellDef>
                <span langkey="phCookieStatement_Table_{{column}}"></span>
              </th>
              <td mat-cell *matCellDef="let element">

                <ng-container *ngIf="isFirst; then iconTemplate else cookieRowTemplate"></ng-container>

                <ng-template #iconTemplate>
                  <div class="row-icons">
                    <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
                    <span>{{element[column]}}</span>
                  </div>
                </ng-template>

                <ng-template #cookieRowTemplate>
                  <ng-container *ngIf="isLast; then optionalTemplate else middleRowTemplate"></ng-container>
                  <ng-template #optionalTemplate>
                    <mat-checkbox class="custom-ripple table-checkmark" id="{{element['cookieName']}}"
                      [checked]="element[column]" [disabled]="element[column]"
                      [ngClass]="element[column] ? 'disabled': ''"
                      [(ngModel)]="!element[column] ? cookieConsentMetaChecked : element[column]"
                      (change)="handleCheckmarkChange($event)">
                    </mat-checkbox>
                  </ng-template>
                </ng-template>

                <ng-template #middleRowTemplate>
                  <span>{{element[column]}}</span>
                </ng-template>

              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="example-element-detail"
                  [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                  <div class="text-container">
                    <div class="inner-left">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_URL"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.URL}}</span>
                      </div>
                    </div>
                    <div class="inner-left">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_company"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.company}}</span>
                      </div>
                    </div>
                    <div class="inner-left">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_technology"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.technology}}</span>
                      </div>
                    </div>
                    <div class="inner-left">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_validity"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.validity}}</span>
                      </div>
                    </div>
                    <div class="inner-left">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_country"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.country}}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-container">
                    <div class="inner-right">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_description"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.description}}</span>
                      </div>
                    </div>
                    <div class="inner-right">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_dataCollect"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.dataCollect.title}}</span>
                        <span>{{element.dataCollect.content1}}</span>
                        <span>{{element.dataCollect.content2}}</span>
                        <span>{{element.dataCollect.content3}}</span>
                        <span>{{element.dataCollect.content4}}</span>
                        <span>{{element.dataCollect.content5}}</span>
                      </div>
                    </div>
                    <div class="inner-right">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_rightTerms"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.rightTerms.title}}</span>
                        <span>{{element.rightTerms.content}}</span>
                      </div>
                    </div>
                    <div class="inner-right">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_dataRecipient"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.dataRecipient}}</span>
                      </div>
                    </div>
                    <div class="inner-right">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_dataProtectionOfficer"></span>
                      </div>
                      <div class="example-element-description">
                        <span>{{element.dataProtectionOfficer.title}}</span>
                        <a class="link-tag"
                          href="mailto:{{element.dataProtectionOfficer.email}}">{{element.dataProtectionOfficer.email}}</a>
                      </div>
                    </div>
                    <div class="inner-right">
                      <div class="table-header mat-header-cell">
                        <span langkey="phCookieStatement_Table_dataProcessors"></span>
                      </div>
                      <div class="example-element-description">
                        <a class="link-tag" href="{{element.dataProcessors}}">{{element.dataProcessors}}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <!-- Expandable Table -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
              [class.example-expanded-row]="expandedElement === element"
              (click)="expandedElement = expandedElement === element ? null : element">
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          </table>

        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="hasMeta; then selectableCookiesTemplate else noSelectableCookiesTemplate"></ng-container>
  <ng-template #noSelectableCookiesTemplate>
    <div class="ya-button-group-wrapper">
      <div class="ya-button-group-container">
        <div class="ya-button-container">
          <button mat-flat-button (click)="closeBottomSheet()">
            <span langkey="phCookieStatement_Button_Close"></span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #selectableCookiesTemplate>
    <div class="ya-button-group-wrapper">
      <div class="ya-button-group-container">
        <div class="ya-button-container">
          <button mat-flat-button (click)="acceptAllCookies()">
            <span langkey="phCookieBanner_Button_Accept_All"></span>
          </button>
        </div>
      </div>
      <div class="ya-button-group-container">
        <div class="ya-button-container">
          <button mat-stroked-button (click)="acceptOptionallCookies()">
            <span langkey="phCookieBanner_Button_Accept"></span>
          </button>
        </div>
        <div class="ya-button-container">
          <button mat-stroked-button (click)="closeBottomSheet()">
            <span langkey="phCookieStatement_Button_Close"></span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="term-container">
    <div class="term-nav">
      <ng-container *ngFor="let term of terms">
        <a a11y_Link (click)="navigateToTerms(term.id)">{{term.label}}</a>
      </ng-container>
    </div>
  </div>
</div>